export default "__VITE_ASSET__93446c83__"